import { AppRoutes } from "enums/routes.enum";
import { useLocation } from "react-router-dom";

export const useCurrentPath = () => {
    const { pathname } = useLocation();

    return {
        isHomePage: pathname === AppRoutes.HOME,
        isAccountPage: pathname === AppRoutes.ACCOUNT,
        isSearchPage: pathname === AppRoutes.SEARCH,
        isLegalPage: pathname === AppRoutes.COOKIE_POLICY || pathname === AppRoutes.TERMS_OF_USE || pathname === AppRoutes.PRIVACY_POLICY,
        isPaymentErrorPage: pathname === AppRoutes.DECLINE,
        isPaymentPage: pathname === AppRoutes.PAYMENT,
        isLostPhonePage: pathname === AppRoutes.HOME_LOST_PHONE,
        isAccountFindDevicePage: pathname === AppRoutes.FIND_DEVICE,
        isAccountLostPhonePage: pathname === AppRoutes.LOST_PHONE,
    };
};
